import React from 'react'
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {BsArrowRight, BsArrowLeft} from "react-icons/bs"
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
import round from '../assets/img/round.svg'
import princess from '../assets/img/princess.svg'
import cushion from '../assets/img/cushion.svg'
import emerald from '../assets/img/emerald.svg'
import oval from '../assets/img/oval.svg'
import radiant from '../assets/img/radiant.svg'
import asscher from '../assets/img/asscher.svg'
import marquise from '../assets/img/marquise.svg'
import heart from '../assets/img/heart.svg'
import pear from '../assets/img/pear.svg'
const ShopByShape = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 10,
        slidesToScroll: 10,
        nextArrow: <span><BsArrowRight /></span>,
        prevArrow: <span><BsArrowLeft /></span>,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 10,
                slidesToScroll: 10,
                infinite: true,
                dots: true,
                autoplay :true,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                initialSlide: 2,
                 autoplay :true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
        ],
        beforeChange: (current, next) => {
            document
              .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
              .forEach(el => el.setAttribute('tabindex', '-1'));
          },
          afterChange: () => {
            document
              .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
              .forEach(el => el.removeAttribute('tabindex'));
          }
    };

    const history = useHistory();

    const shopbyshape = (value) =>{
        var data1 = {
            shape: value,
        } 
        sessionStorage.setItem("bw_d_filter", JSON.stringify(data1));
        history.push('/diamonds');
        window.scrollTo(0, 0);
    }

  return (
    <div className='shapes-slider-section section-padding mr100'>
        <Container>
            <div className="title-box2 text-center main_heading">
                <h2 className="title24">Shop Diamonds By Shape</h2>
            </div>

            <div className='diamond-slider1'>
                <Slider {...settings} className='wrap-item'>
                    <div className="text-center" onClick={()=> shopbyshape('Round')}>
                        <LazyLoadImage src={round} alt='' />
                        <h3 className="RingSettingTitleSPL">Round</h3>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Princess')}>
                        <LazyLoadImage src={princess} alt='' />
                        <h3 className="RingSettingTitleSPL">Princess</h3>
                    </div>
                    
                    <div className="text-center" onClick={()=> shopbyshape('Cushion')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={cushion} alt='' />
                            <h3 className="RingSettingTitleSPL">Cushion</h3>
                        </Link>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Emerald')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={emerald} alt='' />
                            <h3 className="RingSettingTitleSPL">Emerald</h3>
                        </Link>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Oval')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={oval} alt='' />
                            <h3 className="RingSettingTitleSPL">Oval</h3>
                        </Link>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Radiant')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={radiant} alt='' />
                            <h3 className="RingSettingTitleSPL">Radiant</h3>
                        </Link>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Asscher')}>
                        <Link to="/diamond/round" className="shp2">
                            <LazyLoadImage src={asscher} alt='' />
                            <h3 className="RingSettingTitleSPL">Asscher</h3>
                        </Link>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Marquise')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={marquise} alt='' />
                            <h3 className="RingSettingTitleSPL">Marquise</h3>
                        </Link>
                    </div>
                    
                    <div className="text-center" onClick={()=> shopbyshape('Heart')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={heart} alt='' />
                            <h3 className="RingSettingTitleSPL">Heart</h3>
                        </Link>
                    </div>
                    <div className="text-center" onClick={()=> shopbyshape('Pear')}>
                        <Link to="/diamond/round" className="shp3">
                            <LazyLoadImage src={pear} alt='' />
                            <h3 className="RingSettingTitleSPL">Pear</h3>
                        </Link>
                    </div>
                </Slider>
            </div>
        </Container>
    </div>
  )
}

export default ShopByShape